import { React, useContext, useEffect, useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { ToastContainer, toast, Slide } from "react-toastify";
import { API_URL } from "../../utilities/url";
import axios from "axios";
import AuthHeader from "../../services/auth.header";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import CryptoJS from "crypto-js";
import storage from "../../services/storage";
import { FaRegCopy, FaEye, FaEyeSlash } from "react-icons/fa";
import { v4 as uuidv4 } from "uuid";
import { ToastrContext } from "../../provider/toastrContext";
import { Controller, useForm } from "react-hook-form";
import AddDeviceGroupModal from "./component/addDeviceGroupModal";
import authService from "../../services/auth.service";
import { base64_enc } from "../../utilities/ext-function";

var $ = require("jquery");

const AddDevice = () => {
  const location = useLocation();
  const { showCopy } = useContext(ToastrContext);
  const decryptUSR = CryptoJS.AES.decrypt(storage.get("user"), "user").toString(
    CryptoJS.enc.Utf8
  );
  const dt_user = JSON.parse(decryptUSR);
  const decryptWS = CryptoJS.AES.decrypt(storage.get("wrs"), "wrs").toString(
    CryptoJS.enc.Utf8
  );
  const workspace = JSON.parse(decryptWS);
  const navigate = useNavigate();
  const [deviceGroupList, setDeviceGroupList] = useState([]);
  const [hideSpiner, setHideSpiner] = useState(true);
  const [metaTab, setMetaTab] = useState("general");
  const [showSecrets, setShowSecrets] = useState({
    app_secret: false,
    instagram_app_secret: false,
    system_user_token: false,
    webhook_verify_token: false,
    wa_access_token: false,
    msgr_page_token: false,
    ig_access_token: false,
  });
  const toggleSecret = (key) =>
    setShowSecrets((prev) => ({ ...prev, [key]: !prev[key] }));

  useEffect(() => {
    getDeviceGroupList();
    setValue("quota", 1);
    setValue("service_type", "BROADCAST");
    setValue("device_type", "WHATSAPP");
    setValue("msisdn", "+62");
    setValue("min_sending_period", 25);
    setValue("max_sending_period", 60);
    setValue("meta_graph_api_version", "v25.0");
    setValue("meta_ig_auth", "ig_login");
  }, []);

  async function getDeviceGroupList() {
    axios
      .post(
        API_URL + "device-group-list",
        {
          idt_user: dt_user.idt_user,
          idt_user_workspace: workspace.idt_user_workspace,
        },
        {
          headers: AuthHeader(),
        }
      )
      .then((res) => {
        if (res.data.success === true) {
          if (res.data.success === true) {
            const maps = res.data.data.map(function (d) {
              const map = {
                value: d.idt_device_group,
                label: d.name,
              };
              return map;
            });
            setDeviceGroupList(maps);
          }
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  }

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: 4,
      minHeight: 32,
      borderColor: state.isFocused ? "#7f7f7f" : base.borderColor, // Ubah warna border saat fokus
      boxShadow: state.isFocused ? "0 0 0 0.1px #7f7f7f" : base.boxShadow, // Hilangkan shadow bawaan
      "&:hover": {
        borderColor: state.isFocused ? "#7f7f7f" : base.borderColor, // Warna hover
      },
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      padding: 0,
      margin: -2,
    }),
  };

  const {
    handleSubmit,
    register,
    control,
    watch,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();

  const selectedDeviceType = watch("device_type");
  const isMetaApp = selectedDeviceType === "META";
  const enableWhatsapp = watch("enable_whatsapp");
  const enableMessenger = watch("enable_messenger");
  const enableInstagram = watch("enable_instagram");

  const onSubmit = (data) => {
    setHideSpiner(false);

    const isMeta = data.device_type === "META";
    let metaConfigStr = null;
    if (isMeta) {
      const metaConfig = {
        graph_api_version: data.meta_graph_api_version || "",
        app_id: data.meta_app_id || "",
        app_secret: data.meta_app_secret || "",
        instagram_app_secret: data.meta_instagram_app_secret || "",
        system_user_token: data.meta_system_user_token || "",
        webhook_verify_token: data.meta_webhook_verify_token || "",
        auto_reply_text: data.meta_auto_reply_text || "",
        whatsapp: data.enable_whatsapp
          ? {
              phone_number_id: data.meta_wa_phone_number_id || "",
              business_account_id: data.meta_wa_business_account_id || "",
              access_token: data.meta_wa_access_token || "",
            }
          : { phone_number_id: "", business_account_id: "", access_token: "" },
        messenger: data.enable_messenger
          ? {
              page_id: data.meta_msgr_page_id || "",
              page_token: data.meta_msgr_page_token || "",
            }
          : { page_id: "", page_token: "" },
        instagram: data.enable_instagram
          ? {
              auth: data.meta_ig_auth || "ig_login",
              page_id: data.meta_ig_page_id || "",
              user_id: data.meta_ig_user_id || "",
              access_token: data.meta_ig_access_token || "",
            }
          : { auth: "ig_login", page_id: "", user_id: "", access_token: "" },
      };
      metaConfigStr = JSON.stringify(metaConfig);
    }

    axios
      .post(
        API_URL + "add-device",
        {
          idt_user_workspace: workspace.idt_user_workspace,
          name: data.device_name,
          type_device: data.device_type,
          msisdn: isMeta ? "" : data.msisdn.replace("+", ""),
          type_service: data.service_type,
          channel_secret: data.channel_secret,
          channel_at: data.channel_at,
          webhook_url: data.webhook_url,
          idt_device_group: data.device_group.value,
          quota: data.quota,
          min_sending_period: data.min_sending_period,
          max_sending_period: data.max_sending_period,
          meta_config: metaConfigStr,
        },
        {
          headers: AuthHeader(),
        }
      )
      .then((res) => {
        if (res.data.success === true) {
          setHideSpiner(true);
          $("#b-submit").removeClass("disabled");
          localStorage.setItem("alert", true);
          const newId = res.data.data?.idt_device;
          if (isMeta && newId) {
            navigate("/device/edit/" + base64_enc(String(newId)) + "?just_created=1");
          } else {
            navigate("/device");
          }
        } else {
          toast.error(res.data.message, {
            position: "top-right",
            theme: "colored",
            transition: Slide,
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          });
          setHideSpiner(true);
          $("#b-submit").removeClass("disabled");
        }
      })
      .catch((error) => {
        if (error.response.data.message) {
          authService.logout();
        }
      });
  };

  const handleGenerateWCL = () => {
    const newUUID = uuidv4();
    setValue(
      "webhook_url",
      "https://api.otokata.id:5001/callback?s=" + newUUID
    );
    clearErrors("webhook_url");
  };

  /* Copy */
  const handleCopyClick = () => {
    const webhookUrl = watch("webhook_url");
    if (webhookUrl) {
      navigator.clipboard.writeText(webhookUrl);
      showCopy("Webhook URL copied to clipboard");
    }
  };

  // Modal
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="container-fluid p-0">
      <div className="row mb-2 mb-xl-3">
        <div className="col-auto">
          <h5>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/device">Device</Link>
                </li>
                <li className="breadcrumb-item active">Add Device</li>
              </ol>
            </nav>
          </h5>
        </div>
        <ToastContainer />
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="card rounded-4 shadow-lg">
            <div className="col-md-11 col-sm-12 mx-auto">
              <div className="card-header rounded-4">
                <h5 className="card-title text-center">Register Device</h5>
              </div>
              <div className="card-body">
                <div className="card-body h-100">
                  <form id="form-validation" onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      <div className="col-md-6">
                        {/* Device Name */}
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Device Name<span className="required">*</span>
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Device Name"
                              {...register("device_name", {
                                required: "Device Name is required",
                              })}
                            />
                            {errors.device_name && (
                              <span className="text-danger">
                                {errors.device_name.message}
                              </span>
                            )}
                          </div>
                        </div>

                        {/* Device Type */}
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Device Type<span className="required">*</span>
                          </label>
                          <div className="col-sm-8">
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="device_type_1"
                                className="form-check-input"
                                value="WHATSAPP"
                                {...register("device_type", {
                                  required: "Device Type is required",
                                })}
                              />
                              <label
                                htmlFor="device_type_1"
                                className="form-check-label"
                              >
                                WhatsApp
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="device_type_2"
                                className="form-check-input"
                                value="TELEGRAM"
                                {...register("device_type", {
                                  required: "Device Type is required",
                                })}
                              />
                              <label
                                htmlFor="device_type_2"
                                className="form-check-label"
                              >
                                Telegram
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="device_type_3"
                                className="form-check-input"
                                value="LINE"
                                {...register("device_type", {
                                  required: "Device Type is required",
                                })}
                              />
                              <label
                                htmlFor="device_type_3"
                                className="form-check-label"
                              >
                                Line
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="radio"
                                id="device_type_4"
                                className="form-check-input"
                                value="META"
                                {...register("device_type", {
                                  required: "Device Type is required",
                                })}
                              />
                              <label
                                htmlFor="device_type_4"
                                className="form-check-label"
                              >
                                Meta App
                              </label>
                            </div>
                            {/* Error message */}
                            {errors.device_type && (
                              <div className="mt-2">
                                <span className="text-danger">
                                  {errors.device_type.message}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Conditional Inputs */}
                        {selectedDeviceType !== "LINE" && !isMetaApp && (
                          <div className="mb-3 row">
                            <label className="col-form-label col-sm-4 text-sm-right">
                              Nomor MSISDN<span className="required">*</span>
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Nomor MSISDN"
                                {...register("msisdn", {
                                  required: "Nomor MSISDN is required",
                                  pattern: {
                                    value: /^\+?[1-9][0-9]{7,14}$/,
                                    message: "Invalid MSISDN format",
                                  },
                                })}
                              />
                              {errors.msisdn && (
                                <span className="text-danger">
                                  {errors.msisdn.message}
                                </span>
                              )}
                            </div>
                          </div>
                        )}

                        {selectedDeviceType === "LINE" && (
                          <>
                            <div className="mb-3 row">
                              <label className="col-form-label col-sm-4 text-sm-right">
                                Channel Secret
                                <span className="required">*</span>
                              </label>
                              <div className="col-sm-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Channel Secret"
                                  {...register("channel_secret", {
                                    required: "Channel Secret is required",
                                  })}
                                />
                                {errors.channel_secret && (
                                  <span className="text-danger">
                                    {errors.channel_secret.message}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="col-form-label col-sm-4 text-sm-right">
                                Channel Access Token
                                <span className="required">*</span>
                              </label>
                              <div className="col-sm-8">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Channel Access Token"
                                  {...register("channel_at", {
                                    required:
                                      "Channel Access Token is required",
                                  })}
                                />
                                {errors.channel_at && (
                                  <span className="text-danger">
                                    {errors.channel_at.message}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="col-form-label col-sm-4 text-sm-right">
                                Webhook URL<span className="required">*</span>
                              </label>
                              <div className="col-sm-8">
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Webhook URL"
                                    readOnly
                                    {...register("webhook_url", {
                                      required: "Webhook URL is required",
                                    })}
                                  />

                                  <div
                                    className="input-group-text c-pointer"
                                    onClick={handleCopyClick}
                                  >
                                    <FaRegCopy />
                                  </div>
                                  <button
                                    className="btn btn-primary ms-2"
                                    type="button"
                                    onClick={handleGenerateWCL}
                                  >
                                    Generate
                                  </button>
                                </div>
                                {errors.webhook_url && (
                                  <span className="text-danger">
                                    {errors.webhook_url.message}
                                  </span>
                                )}
                              </div>
                            </div>
                          </>
                        )}

                        {/* Device Group */}
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Device Group<span className="required">*</span>
                          </label>
                          <div className="col-sm-8">
                            <Controller
                              name="device_group"
                              control={control}
                              rules={{ required: "Device Group is required" }}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  options={deviceGroupList}
                                  styles={customStyles}
                                  placeholder="Select Device Group"
                                />
                              )}
                            />
                            <div>
                              <Button
                                variant="primary"
                                className="mt-2"
                                onClick={() => setShowModal(true)}
                              >
                                Add Device Group
                              </Button>
                            </div>
                            {errors.device_group && (
                              <span className="text-danger">
                                {errors.device_group.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        {/* Service Type */}
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Service Type
                            <span className="required">*</span>
                          </label>
                          <div className="col-sm-8">
                            <div className="form-group mt-1">
                              <div className="form-check form-check-inline">
                                <input
                                  type="radio"
                                  id="service_type_1"
                                  className="form-check-input"
                                  value="BROADCAST"
                                  {...register("service_type", {
                                    required: "Type Service is required",
                                  })}
                                />
                                <label
                                  htmlFor="service_type_1"
                                  className="form-check-label"
                                >
                                  Broadcast
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  type="radio"
                                  id="service_type_2"
                                  className="form-check-input"
                                  value="RECEIVER"
                                  {...register("service_type", {
                                    required: "Type Service is required",
                                  })}
                                />
                                <label
                                  htmlFor="service_type_2"
                                  className="form-check-label"
                                >
                                  Receiver
                                </label>
                              </div>
                              <div className="form-check form-check-inline">
                                <input
                                  type="radio"
                                  id="service_type_3"
                                  className="form-check-input"
                                  value="HYBRID"
                                  {...register("service_type", {
                                    required: "Type Service is required",
                                  })}
                                />
                                <label
                                  htmlFor="service_type_3"
                                  className="form-check-label"
                                >
                                  Hybrid/Bot
                                </label>
                              </div>
                            </div>

                            {/* Error message */}
                            {errors.service_type && (
                              <div className="mt-2">
                                <span className="text-danger">
                                  {errors.service_type.message}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Quota Per Day */}
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Quota Per Day
                            <span className="required">*</span>
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="number"
                              className="form-control"
                              {...register("quota", {
                                required: "Quota is required",
                                valueAsNumber: true,
                              })}
                              placeholder="Quota"
                            />
                            {errors.quota && (
                              <span className="text-danger">
                                {errors.quota.message}
                              </span>
                            )}
                          </div>
                        </div>

                        {/* Min. Sending Period */}
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Min. Sending Period
                            <span className="required">*</span>
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="number"
                              className="form-control"
                              {...register("min_sending_period", {
                                required: "Minimum sending period is required",
                                valueAsNumber: true,
                              })}
                              placeholder="Min. Sending Period"
                            />
                            {errors.min_sending_period && (
                              <span className="text-danger">
                                {errors.min_sending_period.message}
                              </span>
                            )}
                          </div>
                        </div>

                        {/* Max. Sending Period */}
                        <div className="mb-3 row">
                          <label className="col-form-label col-sm-4 text-sm-right">
                            Max. Sending Period
                            <span className="required">*</span>
                          </label>
                          <div className="col-sm-8">
                            <input
                              type="number"
                              className="form-control"
                              {...register("max_sending_period", {
                                required: "Maximum sending period is required",
                                valueAsNumber: true,
                              })}
                              placeholder="Max. Sending Period"
                            />
                            {errors.max_sending_period && (
                              <span className="text-danger">
                                {errors.max_sending_period.message}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {isMetaApp && (
                      <div className="row">
                        <div className="col-12">
                          <hr />
                          <h6 className="mb-3">Meta App Configuration</h6>
                          <Tab.Container
                            activeKey={metaTab}
                            onSelect={(k) => setMetaTab(k || "general")}
                          >
                            <Nav variant="tabs" className="mb-3">
                              <Nav.Item>
                                <Nav.Link eventKey="general">
                                  General<span className="required">*</span>
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item>
                                <Nav.Link eventKey="whatsapp">
                                  WhatsApp Business API
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item>
                                <Nav.Link eventKey="messenger">
                                  Messenger
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item>
                                <Nav.Link eventKey="instagram">
                                  Instagram
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>
                            <Tab.Content>
                              {/* General */}
                              <Tab.Pane eventKey="general">
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Graph API Version
                                        <span className="required">*</span>
                                      </label>
                                      <div className="col-sm-8">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="v25.0"
                                          {...register("meta_graph_api_version", {
                                            required: isMetaApp
                                              ? "Graph API Version is required"
                                              : false,
                                          })}
                                        />
                                        {errors.meta_graph_api_version && (
                                          <span className="text-danger">
                                            {errors.meta_graph_api_version.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        App ID
                                        <span className="required">*</span>
                                      </label>
                                      <div className="col-sm-8">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="App ID"
                                          {...register("meta_app_id", {
                                            required: isMetaApp
                                              ? "App ID is required"
                                              : false,
                                          })}
                                        />
                                        {errors.meta_app_id && (
                                          <span className="text-danger">
                                            {errors.meta_app_id.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        App Secret
                                        <span className="required">*</span>
                                      </label>
                                      <div className="col-sm-8">
                                        <div className="input-group">
                                          <input
                                            type={
                                              showSecrets.app_secret
                                                ? "text"
                                                : "password"
                                            }
                                            className="form-control"
                                            placeholder="App Secret"
                                            {...register("meta_app_secret", {
                                              required: isMetaApp
                                                ? "App Secret is required"
                                                : false,
                                            })}
                                          />
                                          <span
                                            className="input-group-text c-pointer"
                                            onClick={() =>
                                              toggleSecret("app_secret")
                                            }
                                          >
                                            {showSecrets.app_secret ? (
                                              <FaEyeSlash />
                                            ) : (
                                              <FaEye />
                                            )}
                                          </span>
                                        </div>
                                        {errors.meta_app_secret && (
                                          <span className="text-danger">
                                            {errors.meta_app_secret.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Instagram App Secret
                                        <span className="required">*</span>
                                      </label>
                                      <div className="col-sm-8">
                                        <div className="input-group">
                                          <input
                                            type={
                                              showSecrets.instagram_app_secret
                                                ? "text"
                                                : "password"
                                            }
                                            className="form-control"
                                            placeholder="Instagram App Secret"
                                            {...register(
                                              "meta_instagram_app_secret",
                                              {
                                                required: isMetaApp
                                                  ? "Instagram App Secret is required"
                                                  : false,
                                              }
                                            )}
                                          />
                                          <span
                                            className="input-group-text c-pointer"
                                            onClick={() =>
                                              toggleSecret("instagram_app_secret")
                                            }
                                          >
                                            {showSecrets.instagram_app_secret ? (
                                              <FaEyeSlash />
                                            ) : (
                                              <FaEye />
                                            )}
                                          </span>
                                        </div>
                                        {errors.meta_instagram_app_secret && (
                                          <span className="text-danger">
                                            {
                                              errors.meta_instagram_app_secret
                                                .message
                                            }
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        System User Token
                                        <span className="required">*</span>
                                      </label>
                                      <div className="col-sm-8">
                                        <div className="input-group">
                                          <textarea
                                            rows={2}
                                            className="form-control font-monospace"
                                            placeholder="System User Token"
                                            style={{
                                              WebkitTextSecurity: showSecrets.system_user_token
                                                ? "none"
                                                : "disc",
                                            }}
                                            {...register(
                                              "meta_system_user_token",
                                              {
                                                required: isMetaApp
                                                  ? "System User Token is required"
                                                  : false,
                                              }
                                            )}
                                          />
                                          <span
                                            className="input-group-text c-pointer"
                                            onClick={() =>
                                              toggleSecret("system_user_token")
                                            }
                                          >
                                            {showSecrets.system_user_token ? (
                                              <FaEyeSlash />
                                            ) : (
                                              <FaEye />
                                            )}
                                          </span>
                                        </div>
                                        {errors.meta_system_user_token && (
                                          <span className="text-danger">
                                            {errors.meta_system_user_token.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Webhook Verify Token
                                        <span className="required">*</span>
                                      </label>
                                      <div className="col-sm-8">
                                        <div className="input-group">
                                          <input
                                            type={
                                              showSecrets.webhook_verify_token
                                                ? "text"
                                                : "password"
                                            }
                                            className="form-control"
                                            placeholder="Webhook Verify Token"
                                            {...register(
                                              "meta_webhook_verify_token",
                                              {
                                                required: isMetaApp
                                                  ? "Webhook Verify Token is required"
                                                  : false,
                                              }
                                            )}
                                          />
                                          <span
                                            className="input-group-text c-pointer"
                                            onClick={() =>
                                              toggleSecret("webhook_verify_token")
                                            }
                                          >
                                            {showSecrets.webhook_verify_token ? (
                                              <FaEyeSlash />
                                            ) : (
                                              <FaEye />
                                            )}
                                          </span>
                                        </div>
                                        {errors.meta_webhook_verify_token && (
                                          <span className="text-danger">
                                            {
                                              errors.meta_webhook_verify_token
                                                .message
                                            }
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Auto Reply Text
                                      </label>
                                      <div className="col-sm-8">
                                        <textarea
                                          rows={2}
                                          className="form-control"
                                          placeholder="Optional auto-reply"
                                          {...register("meta_auto_reply_text")}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Tab.Pane>

                              {/* WhatsApp Business API */}
                              <Tab.Pane eventKey="whatsapp">
                                <div className="form-check mb-3">
                                  <input
                                    type="checkbox"
                                    id="enable_whatsapp"
                                    className="form-check-input"
                                    {...register("enable_whatsapp")}
                                  />
                                  <label
                                    htmlFor="enable_whatsapp"
                                    className="form-check-label"
                                  >
                                    Enable WhatsApp Business API
                                  </label>
                                </div>
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Phone Number ID
                                        {enableWhatsapp && (
                                          <span className="required">*</span>
                                        )}
                                      </label>
                                      <div className="col-sm-8">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Phone Number ID"
                                          disabled={!enableWhatsapp}
                                          {...register(
                                            "meta_wa_phone_number_id",
                                            {
                                              required:
                                                isMetaApp && enableWhatsapp
                                                  ? "Phone Number ID is required"
                                                  : false,
                                            }
                                          )}
                                        />
                                        {errors.meta_wa_phone_number_id && (
                                          <span className="text-danger">
                                            {
                                              errors.meta_wa_phone_number_id
                                                .message
                                            }
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Business Account ID
                                        {enableWhatsapp && (
                                          <span className="required">*</span>
                                        )}
                                      </label>
                                      <div className="col-sm-8">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Business Account ID"
                                          disabled={!enableWhatsapp}
                                          {...register(
                                            "meta_wa_business_account_id",
                                            {
                                              required:
                                                isMetaApp && enableWhatsapp
                                                  ? "Business Account ID is required"
                                                  : false,
                                            }
                                          )}
                                        />
                                        {errors.meta_wa_business_account_id && (
                                          <span className="text-danger">
                                            {
                                              errors.meta_wa_business_account_id
                                                .message
                                            }
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Access Token
                                        {enableWhatsapp && (
                                          <span className="required">*</span>
                                        )}
                                      </label>
                                      <div className="col-sm-8">
                                        <div className="input-group">
                                          <textarea
                                            rows={2}
                                            className="form-control font-monospace"
                                            placeholder="Access Token"
                                            disabled={!enableWhatsapp}
                                            style={{
                                              WebkitTextSecurity: showSecrets.wa_access_token
                                                ? "none"
                                                : "disc",
                                            }}
                                            {...register(
                                              "meta_wa_access_token",
                                              {
                                                required:
                                                  isMetaApp && enableWhatsapp
                                                    ? "Access Token is required"
                                                    : false,
                                              }
                                            )}
                                          />
                                          <span
                                            className="input-group-text c-pointer"
                                            onClick={() =>
                                              toggleSecret("wa_access_token")
                                            }
                                          >
                                            {showSecrets.wa_access_token ? (
                                              <FaEyeSlash />
                                            ) : (
                                              <FaEye />
                                            )}
                                          </span>
                                        </div>
                                        {errors.meta_wa_access_token && (
                                          <span className="text-danger">
                                            {errors.meta_wa_access_token.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Tab.Pane>

                              {/* Messenger */}
                              <Tab.Pane eventKey="messenger">
                                <div className="form-check mb-3">
                                  <input
                                    type="checkbox"
                                    id="enable_messenger"
                                    className="form-check-input"
                                    {...register("enable_messenger")}
                                  />
                                  <label
                                    htmlFor="enable_messenger"
                                    className="form-check-label"
                                  >
                                    Enable Messenger
                                  </label>
                                </div>
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Page ID
                                        {enableMessenger && (
                                          <span className="required">*</span>
                                        )}
                                      </label>
                                      <div className="col-sm-8">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Page ID"
                                          disabled={!enableMessenger}
                                          {...register("meta_msgr_page_id", {
                                            required:
                                              isMetaApp && enableMessenger
                                                ? "Page ID is required"
                                                : false,
                                          })}
                                        />
                                        {errors.meta_msgr_page_id && (
                                          <span className="text-danger">
                                            {errors.meta_msgr_page_id.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Page Token
                                        {enableMessenger && (
                                          <span className="required">*</span>
                                        )}
                                      </label>
                                      <div className="col-sm-8">
                                        <div className="input-group">
                                          <textarea
                                            rows={2}
                                            className="form-control font-monospace"
                                            placeholder="Page Token"
                                            disabled={!enableMessenger}
                                            style={{
                                              WebkitTextSecurity: showSecrets.msgr_page_token
                                                ? "none"
                                                : "disc",
                                            }}
                                            {...register("meta_msgr_page_token", {
                                              required:
                                                isMetaApp && enableMessenger
                                                  ? "Page Token is required"
                                                  : false,
                                            })}
                                          />
                                          <span
                                            className="input-group-text c-pointer"
                                            onClick={() =>
                                              toggleSecret("msgr_page_token")
                                            }
                                          >
                                            {showSecrets.msgr_page_token ? (
                                              <FaEyeSlash />
                                            ) : (
                                              <FaEye />
                                            )}
                                          </span>
                                        </div>
                                        {errors.meta_msgr_page_token && (
                                          <span className="text-danger">
                                            {errors.meta_msgr_page_token.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Tab.Pane>

                              {/* Instagram */}
                              <Tab.Pane eventKey="instagram">
                                <div className="form-check mb-3">
                                  <input
                                    type="checkbox"
                                    id="enable_instagram"
                                    className="form-check-input"
                                    {...register("enable_instagram")}
                                  />
                                  <label
                                    htmlFor="enable_instagram"
                                    className="form-check-label"
                                  >
                                    Enable Instagram
                                  </label>
                                </div>
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Auth Method
                                        {enableInstagram && (
                                          <span className="required">*</span>
                                        )}
                                      </label>
                                      <div className="col-sm-8">
                                        <select
                                          className="form-select"
                                          disabled={!enableInstagram}
                                          {...register("meta_ig_auth", {
                                            required:
                                              isMetaApp && enableInstagram
                                                ? "Auth Method is required"
                                                : false,
                                          })}
                                        >
                                          <option value="ig_login">
                                            ig_login
                                          </option>
                                          <option value="fb_login">
                                            fb_login
                                          </option>
                                        </select>
                                        {errors.meta_ig_auth && (
                                          <span className="text-danger">
                                            {errors.meta_ig_auth.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Page ID
                                        {enableInstagram && (
                                          <span className="required">*</span>
                                        )}
                                      </label>
                                      <div className="col-sm-8">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Page ID"
                                          disabled={!enableInstagram}
                                          {...register("meta_ig_page_id", {
                                            required:
                                              isMetaApp && enableInstagram
                                                ? "Page ID is required"
                                                : false,
                                          })}
                                        />
                                        {errors.meta_ig_page_id && (
                                          <span className="text-danger">
                                            {errors.meta_ig_page_id.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        User ID
                                        {enableInstagram && (
                                          <span className="required">*</span>
                                        )}
                                      </label>
                                      <div className="col-sm-8">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="User ID"
                                          disabled={!enableInstagram}
                                          {...register("meta_ig_user_id", {
                                            required:
                                              isMetaApp && enableInstagram
                                                ? "User ID is required"
                                                : false,
                                          })}
                                        />
                                        {errors.meta_ig_user_id && (
                                          <span className="text-danger">
                                            {errors.meta_ig_user_id.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="mb-3 row">
                                      <label className="col-form-label col-sm-4 text-sm-right">
                                        Access Token
                                        {enableInstagram && (
                                          <span className="required">*</span>
                                        )}
                                      </label>
                                      <div className="col-sm-8">
                                        <div className="input-group">
                                          <textarea
                                            rows={2}
                                            className="form-control font-monospace"
                                            placeholder="Access Token"
                                            disabled={!enableInstagram}
                                            style={{
                                              WebkitTextSecurity: showSecrets.ig_access_token
                                                ? "none"
                                                : "disc",
                                            }}
                                            {...register(
                                              "meta_ig_access_token",
                                              {
                                                required:
                                                  isMetaApp && enableInstagram
                                                    ? "Access Token is required"
                                                    : false,
                                              }
                                            )}
                                          />
                                          <span
                                            className="input-group-text c-pointer"
                                            onClick={() =>
                                              toggleSecret("ig_access_token")
                                            }
                                          >
                                            {showSecrets.ig_access_token ? (
                                              <FaEyeSlash />
                                            ) : (
                                              <FaEye />
                                            )}
                                          </span>
                                        </div>
                                        {errors.meta_ig_access_token && (
                                          <span className="text-danger">
                                            {errors.meta_ig_access_token.message}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Tab.Pane>
                            </Tab.Content>
                          </Tab.Container>
                        </div>
                      </div>
                    )}

                    <div className="mt-4">
                      <Link to="/device" className="btn btn-danger btn-md">
                        Cancel
                      </Link>
                      <button
                        type="submit"
                        className="btn btn-success btn-md float-end"
                      >
                        <span
                          className={`spinner-border spinner-border-xs me-2 ${
                            hideSpiner ? "d-none" : ""
                          }`}
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Modal */}
      <AddDeviceGroupModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        onChangeData={() => getDeviceGroupList()}
      />
    </div>
  );
};

export default AddDevice;
